import React from 'react';

export const ArrowBack: React.FC<React.SVGAttributes<SVGElement>> = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.828 8.99983L9.192 14.3638L7.778 15.7778L0 7.99983L7.778 0.221832L9.192 1.63583L3.828 6.99983L16 6.99983V8.99983L3.828 8.99983Z'
      fill='#7668B1'
    />
  </svg>
);
